import React, { useCallback } from 'react';
import type { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Analytics } from '@trello/atlassian-analytics';
import { forTemplate } from '@trello/i18n';
import { OverflowMenuHorizontalIcon } from '@trello/nachos/icons/overflow-menu-horizontal';
import styles from './BoardHeaderShowSidebarButton.less';
import { DynamicButton } from '@trello/dynamic-tokens';

const format = forTemplate('board_header');
interface BoardHeaderShowSidebarButtonProps {
  showSidebar: () => void;
  eventContainers: {
    board: {
      id: string;
    };
    organization: {
      id: string;
    };
  };
}

export const BoardHeaderShowSidebarButton: FunctionComponent<BoardHeaderShowSidebarButtonProps> = ({
  showSidebar,
  eventContainers,
}) => {
  const handleOnClick = useCallback(() => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'showSidebarButton',
      source: 'boardScreen',
      containers: eventContainers,
    });
    showSidebar();
  }, [showSidebar, eventContainers]);

  return (
    <DynamicButton
      className={classNames(styles.showSidebarButton)}
      aria-label={format('show-menu')}
      iconBefore={<OverflowMenuHorizontalIcon size={'medium'} />}
      onClick={handleOnClick}
    />
  );
};
